module.exports = __webpack_public_path__ + "static/media/Niveles.d830966f.svg";